import React, { FC, useCallback, useState } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { notification, useMe, Avatar, Button } from 'src/common';
import { ColorPicker } from 'src/shared';
import { DEFAULT_WORKSPACE_COLORS } from 'src/models/workspace/types';
import { useUpdateUser } from 'src/models/users/Account/hooks';

interface IProps {}

export const AvatarSettings: FC<IProps> = () => {
  const { t } = useTranslation();

  const { data: user } = useMe();
  const email = user?.email;

  const [color, setColor] = useState(user?.color);

  const [updateUser] = useUpdateUser();

  const onColorChange = useCallback(
    (color: string) => {
      email &&
        updateUser({ variables: { email, color } }).catch(() => {
          notification.error({
            description: t('Common.unknownErrorDesc'),
            message: t('Common.unknownError')
          });
        });
    },
    [email, t, updateUser]
  );

  return user ? (
    <div className={styles.user}>
      <Avatar user={{ ...user, color: color || user.color }} className={styles.avatarPic} size={'xl'} />
      <ColorPicker
        currentColor={color || user.color}
        onChange={setColor}
        onSubmit={onColorChange}
        paletteColors={DEFAULT_WORKSPACE_COLORS}
        placement={'bottomRight'}
      >
        <Button type={'default'} className={styles.button}>
          {t('Common.change')}
        </Button>
      </ColorPicker>
    </div>
  ) : null;
};

export default AvatarSettings;
